import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Grid, useTheme } from "@mui/material";

//src
import { Common } from "../../common/src";

// fontAwesome
import { Logo } from "./Parts/Logo";
import { LangMenu } from "./Parts/LangMenu";
import { HelpMenu } from "./Parts/HelpMenu";
import { UserMenu } from "./Parts/UserMenu";

type NaviPropsType = {
  userInfo: Common.LandlogNecessaryUserInfo;
};

const NavBar = (props: NaviPropsType) => {
  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.main,
  };

  return (
    <AppBar
      sx={{
        backgroundColor: customColor.color,
        borderBottom: "solid 1px  rgb(67, 67, 72)",
        height: "40px",
        boxShadow: "none",
        position: "static",
        padding: "0px 16px !important",
      }}
    >
      <Toolbar
        disableGutters
        style={{
          backgroundColor: customColor.color,
          borderBottom: "solid 1px  rgb(67, 67, 72)",
          minHeight: "40px",
          justifyContent: "space-between",
        }}
      >
        <Grid xs={2}>
          <Logo />
        </Grid>
        <Grid
          xs={10}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          {/* <LangMenu /> */}
          <HelpMenu
            userLang={props.userInfo ? props.userInfo.language : ""}
            username={props.userInfo ? props.userInfo.name : ""}
            mail={props.userInfo ? props.userInfo.email : ""}
            pic={props.userInfo ? props.userInfo.picture : ""}
          />
          <UserMenu
            userLang={props.userInfo ? props.userInfo.language : ""}
            username={props.userInfo ? props.userInfo.name : ""}
            mail={props.userInfo ? props.userInfo.email : ""}
            pic={props.userInfo ? props.userInfo.picture : ""}
          />
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
